import { User } from '../../models';

export const validAccountIcon = 'https://d1h3p5fzmizjvp.cloudfront.net/themes/katalon_4/images/pages/account/tick1.png';
export const invalidAccountIcon = 'https://d1h3p5fzmizjvp.cloudfront.net/themes/katalon_4/images/pages/account/icon_error.svg';
export interface StyleProps {
  status: string;
}
export const getUserFullName = (user: User | null) => `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
